import React from 'react';
import './App.css';
import RedPacket from './components/RedPacket';

function App() {
  return (
    <div className="App">
      <div className="background-image">
        <div className="container">
          <RedPacket />
        </div>
      </div>
    </div>
  );
}

export default App;
